import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { useTheme } from '@emotion/react';

import theme from 'constants/theme';

import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

export const ScaleRating = ({ options = [], onSelectHandler, selectedValue, isDisabled = false }) => {
  const { colors } = useTheme();
  const descriptionText1 = options[0]?.description;
  const descriptionText2 = options[options.length - 1]?.description;

  return (
    <Flex direction="column" width="max-content">
      <Flex direction="row" gap="10px" width="max-content" opacity={isDisabled ? '0.5' : '1'}>
        {options.map(({ score, id }) => (
          <Box
            pointerEvents={isDisabled ? 'none' : 'auto'}
            onClick={() => onSelectHandler(id)}
            _hover={{
              background: selectedValue === id ? colors.button.blue.focus : colors.white,
              border: `1px solid ${colors.button.blue.focus}`,
            }}
            background={selectedValue === id ? colors.button.blue.focus : colors.transparent}
            value={selectedValue}
            display="flex"
            py="8px"
            px="14px"
            border={selectedValue === id ? `1px solid ${colors.button.blue.focus}` : `1px solid ${colors.text.g3}`}
            borderRadius="4px"
            cursor="pointer"
          >
            <TextLabel bold color={selectedValue === id ? colors.white : colors.text.g2}>
              {score}
            </TextLabel>
          </Box>
        ))}
      </Flex>

      {!!descriptionText1 && !!descriptionText2 && (
        <Flex justifyContent="space-between" paddingTop="16px" width="100%">
          <TextBodyMedium
            color={theme.palette.text.label}
            width="50px"
            whiteSpace="pre-wrap"
            overflowWrap="normal"
            textAlign="start"
          >
            {descriptionText1}
          </TextBodyMedium>
          <TextBodyMedium color={theme.palette.text.label} width="50px" whiteSpace="pre-wrap" textAlign="end">
            {descriptionText2}
          </TextBodyMedium>
        </Flex>
      )}
    </Flex>
  );
};
